import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { fetchDailyUsage, type DailyUsageResponse } from '../data/dailyUsage';

export function useDailyUsage() {
  const { user, getIdToken } = useAuth();
  const [usage, setUsage] = useState<DailyUsageResponse | null>(null);
  const [loading, setLoading] = useState(Boolean(user));

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    getIdToken()
      .then((token) => {
        if (!token) throw new Error('Sem token de autenticação para ler o uso diário');
        return fetchDailyUsage(token);
      })
      .then(setUsage)
      .catch((err) => console.error('Falha ao ler /api/usage/today', err))
      .finally(() => setLoading(false));
  }, [user, getIdToken]);

  return { usage, loading };
}
